(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('ztz-product')) {
    customElements.define('ztz-product', class extends HTMLElement {
      connectedCallback() {
        this.controller = null;
        this.description = this.querySelector('[data-description-media]');
        if (this.description) {
          this.onDescriptionError = event => {
            if (!(event.target instanceof HTMLImageElement)) return;
            event.target.hidden = true;
            this.querySelector('[data-description-image-note]').hidden = false;
          };
          this.description.addEventListener('error', this.onDescriptionError, true);
          this.description.querySelectorAll('img').forEach(img => {
            if (img.complete && img.naturalWidth === 0 && (img.currentSrc || img.getAttribute('src'))) this.onDescriptionError({ target: img });
          });
        }
        const enhanced = this.querySelector('[data-enhanced-picker]');
        if (enhanced) { enhanced.hidden = false; this.querySelector('[data-native-picker]').hidden = true; }
        this.addEventListener('change', this.onChange = event => {
          if (event.target.matches('[data-option-select]')) this.updateOption(event.target);
        });
        this.addEventListener('submit', this.onSubmit = event => {
          if (this.getAttribute('aria-busy') === 'true') event.preventDefault();
        });
        this.addEventListener('click', this.onClick = event => {
          const optionButton = event.target.closest('[data-option-button]');
          if (optionButton) {
            const group = optionButton.closest('.ztz-pdp__option');
            const select = group.querySelector('[data-option-select]');
            if (select.value === optionButton.dataset.optionValueId && this.getAttribute('aria-busy') !== 'true') return;
            select.value = optionButton.dataset.optionValueId;
            group.querySelectorAll('[data-option-button]').forEach(button => button.setAttribute('aria-pressed', String(button === optionButton)));
            select.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          const thumb = event.target.closest('[data-gallery-image]');
          if (!thumb) return;
          const img = this.querySelector('[data-main-image]');
          if (img) { img.src = thumb.dataset.src; img.removeAttribute('srcset'); img.alt = thumb.dataset.alt; }
          this.querySelectorAll('[data-gallery-image]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
        });
        const purchase = this.querySelector('[data-add-button]');
        const sticky = this.querySelector('[data-sticky-purchase]');
        if (purchase && sticky && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
          }, { threshold: 0 });
          this.observer.observe(purchase);
        }
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.description?.removeEventListener('error', this.onDescriptionError, true); this.removeEventListener('change', this.onChange); this.removeEventListener('click', this.onClick); this.removeEventListener('submit', this.onSubmit); }
      async updateOption(input) {
        this.controller?.abort();
        this.controller = new AbortController();
        const selected = input.selectedOptions[0];
        const url = new URL(selected.dataset.productUrl || this.dataset.productUrl, location.origin);
        const optionValues = Array.from(this.querySelectorAll('[data-option-select]')).map(select => select.value);
        url.searchParams.set('option_values', optionValues.join(','));
        url.searchParams.set('section_id', this.dataset.sectionId);
        const status = this.querySelector('[data-product-status]');
        const quantity = this.querySelector('[data-quantity]').value;
        const focusPosition = input.dataset.optionPosition;
        this.setAttribute('aria-busy', 'true');
        this.querySelectorAll('[data-add-button],[data-sticky-add]').forEach(button => button.disabled = true);
        const express = this.querySelector('.ztz-pdp__express');
        if (express) express.hidden = true;
        status.textContent = status.dataset.loading;
        try {
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error('Section response failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const replacement = html.querySelector('ztz-product');
          if (!replacement) throw new Error('Product section missing');
          const nextQuantity = replacement.querySelector('[data-quantity]');
          const min = Number(nextQuantity.min) || 1;
          const max = Number(nextQuantity.max) || Infinity;
          const step = Number(nextQuantity.step) || 1;
          const candidate = Math.min(max, Math.max(min, Number(quantity) || min));
          nextQuantity.value = String(min + Math.floor((candidate - min) / step) * step);
          url.searchParams.delete('section_id');
          if (replacement.dataset.variantId) { url.searchParams.delete('option_values'); url.searchParams.set('variant', replacement.dataset.variantId); }
          history.replaceState({}, '', url);
          this.replaceWith(replacement);
          replacement.querySelector(`[data-option-button][data-option-position="${focusPosition}"][aria-pressed="true"]`)?.focus({ preventScroll: true });
          window.Shopify?.PaymentButton?.init();
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.removeAttribute('aria-busy');
          const reload = document.createElement('a');
          url.searchParams.delete('section_id');
          reload.href = url.toString();
          reload.textContent = status.dataset.error;
          status.replaceChildren(reload);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"]) return;
  try {
    
  document.querySelectorAll('[data-form-feedback]').forEach((feedback) => { feedback.focus({ preventScroll: true }); feedback.scrollIntoView({ block: 'center' }); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ztz-retail-header"]) return;
  try {
    
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!event.target.closest('ztz-currency-selector'))document.querySelectorAll('.retail-header details[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus()})});
  document.addEventListener('click',event=>document.querySelectorAll('.retail-header details[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ztz-wheel-size-article"]) return;
  try {
    
  (() => {
    function initialize(root) {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const dialog = root.querySelector('dialog');
      const links = [...root.querySelectorAll('.article-toc a')];
      let trigger = null, previousOverflow = '', frame = 0;
      const update = () => {
        frame = 0;
        let active = links[0];
        links.forEach(link => {
          const target = root.querySelector(link.hash);
          if (target && target.getBoundingClientRect().top <= 145) active = link;
        });
        links.forEach(link => {
          if (link === active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      root.querySelectorAll('[data-guide-open]').forEach(button => button.addEventListener('click', () => {
        trigger = button;
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        dialog.querySelector('input')?.focus();
      }));
      dialog.querySelector('[data-guide-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow;
        trigger?.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', event => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      });
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      root.addEventListener('guide:destroy', () => {
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        cancelAnimationFrame(frame);
        if (dialog.open) dialog.close();
      }, { once: true });
      update();
    }
    document.querySelectorAll('[data-wheel-guide]').forEach(initialize);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wheel-guide]').forEach(initialize));
    document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-wheel-guide]').forEach(root => root.dispatchEvent(new Event('guide:destroy'))));
  })();

  } catch(e) { console.error(e); }
})();
})();
